import React, { useEffect } from 'react';
import './Doors.css';
import leftDoorImg2 from '../LD2_Blue2.png';
import rightDoorImg2 from '../RD2_Blue2.png';

const Doors = ({ isOpen, animating, onOpened }) => {
    useEffect(() => {
        if (!isOpen) return;
        const timer = setTimeout(onOpened, 0); // match CSS duration
        return () => clearTimeout(timer);
    }, [isOpen, onOpened]);

    const showBlue = animating || isOpen;

    return (
        <div className={`door-app-container ${isOpen ? 'open' : ''}`}>
            <img
                src={leftDoorImg2}
                alt="Left Door"
                className="door-app-left"
            />
            <img
                src={rightDoorImg2}
                alt="Right Door"
                className="door-app-right"
            />
        </div>
    );
};

export default Doors;